import "./Service.module.css";
import Header from "@/reusable_sections/Header";
import Ota from "./sections/Ota";
import Revenue from "./sections/Revenue";
import Marketing from "./sections/Marketing";
import Optimization from "./sections/Optimization";
import RevenueServices from "./sections/RevenueServices";
import Footer from "@/reusable_sections/Footer";
export default function ServicePage() {
  return <div>
      <Header />
      <Ota />
      <Revenue />
      <Marketing />
      <Optimization />
      <RevenueServices />
      <Footer />
    </div>;
}